import { useContext } from 'react';
import AuthContext from 'src/contexts/AuthContext';

const useAuth = () => {
  return useContext(AuthContext);
};

export default useAuth;
